import { useState } from 'react';
import axios from 'axios';
import { useModal } from '../components/Modal';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const QR_IMAGE = 'https://firesocial24.com/wp-content/uploads/2026/06/qrcode.jpg';

function TopupPage({ user, dark, onBack, onSuccess }) {
  const { showModal } = useModal();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const c = {
    bg: dark ? '#0d0d0d' : '#f8f8f8',
    card: dark ? '#1c1c1c' : '#ffffff',
    cardBorder: dark ? '#2e2e2e' : '#e8e8e8',
    text: dark ? '#eeeeee' : '#111111',
    sub: dark ? '#555555' : '#aaaaaa',
    inp: dark ? '#252525' : '#f5f5f5',
    inpBorder: dark ? '#383838' : '#e0e0e0',
    inpText: dark ? '#eeeeee' : '#111111',
  };

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;

    if (f.size > 4 * 1024 * 1024) {
      showModal({ type: 'warning', title: 'ไฟล์ใหญ่เกินไป', message: 'กรุณาอัปโหลดภาพสลิปขนาดไม่เกิน 4MB ค่ะ' });
      return;
    }

    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const handleSubmit = async () => {
    if (!file) {
      showModal({ type: 'warning', title: 'ยังไม่ได้แนบสลิป', message: 'กรุณาเลือกรูปสลิปก่อนค่ะ' });
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('slip', file);
      formData.append('lineUserId', user.userId);
      if (amount) formData.append('amount', amount);

      const res = await axios.post(`${BACKEND}/upload-slip`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (res.data.success) {
        setResult(res.data);
      } else {
        showModal({ type: 'error', title: 'ตรวจสอบสลิปไม่สำเร็จ', message: res.data.message || 'กรุณาลองใหม่อีกครั้งค่ะ' });
      }
    } catch (err) {
      showModal({ type: 'error', title: 'เชื่อมต่อไม่สำเร็จ', message: 'ระบบขัดข้องชั่วคราวค่ะ กรุณาลองใหม่อีกครั้งค่ะ' });
    }
    setLoading(false);
  };

  if (result?.success) {
    return (
      <div style={{padding:'20px',display:'flex',flexDirection:'column',alignItems:'center',gap:'12px',background:c.bg,minHeight:'100vh',fontFamily:'Prompt,sans-serif'}}>
        <div style={{width:'60px',height:'60px',borderRadius:'50%',background:dark?'#1a0800':'#fff5f0',border:'2px solid #FF4500',display:'flex',alignItems:'center',justifyContent:'center',marginTop:'40px'}}>
          <i className="ti ti-check" style={{fontSize:'28px',color:'#FF4500'}} aria-hidden="true"/>
        </div>
        <p style={{fontSize:'16px',fontWeight:'700',color:c.text}}>เติมเครดิตสำเร็จแล้วค่ะ!</p>
        <p style={{fontSize:'22px',fontWeight:'700',color:'#FF4500'}}>+฿{Number(result.amount).toFixed(2)}</p>
        <p style={{fontSize:'12px',color:c.sub,textAlign:'center'}}>ยอดเงินคงเหลือ ฿{Number(result.newBalance).toFixed(2)}</p>
        <button onClick={onSuccess} style={{width:'100%',padding:'12px',border:'none',borderRadius:'10px',background:'#FF4500',color:'#fff',fontSize:'13px',fontWeight:'600',cursor:'pointer',fontFamily:'Prompt,sans-serif',marginTop:'12px'}}>
          กลับไปหน้าเครดิต
        </button>
      </div>
    );
  }

  return (
    <div style={{padding:'12px',display:'flex',flexDirection:'column',gap:'10px',background:c.bg,minHeight:'100vh',fontFamily:'Prompt,sans-serif'}}>

      <button onClick={onBack} style={{display:'flex',alignItems:'center',gap:'6px',background:'none',border:'none',cursor:'pointer',color:c.sub,padding:'4px 0',fontFamily:'Prompt,sans-serif',fontSize:'13px'}}>
        <i className="ti ti-arrow-left" style={{fontSize:'16px'}} aria-hidden="true"/>
        กลับ
      </button>

      <p style={{fontSize:'15px',fontWeight:'700',color:c.text,margin:0}}>เติมเครดิตค่ะ</p>

      {/* ข้อความแจ้งขั้นต่ำ */}
      <div style={{background:dark?'#2a1800':'#fff8e0',border:'1px solid #f59e0b',borderRadius:'10px',padding:'8px 12px',display:'flex',alignItems:'center',gap:'8px'}}>
        <i className="ti ti-info-circle" style={{fontSize:'15px',color:'#f59e0b',flexShrink:0}} aria-hidden="true"/>
        <p style={{fontSize:'11px',color:dark?'#fbbf24':'#92400e',margin:0}}>ยอดเติมขั้นต่ำ <b>฿50</b> ค่ะ</p>
      </div>

      <div style={{background:c.card,border:`1px solid ${c.cardBorder}`,borderRadius:'12px',padding:'16px',textAlign:'center'}}>
        <img src={QR_IMAGE} alt="QR Code ร้าน" style={{width:'200px',maxWidth:'100%',borderRadius:'8px',display:'block',margin:'0 auto'}} />
        <p style={{fontSize:'11px',color:c.sub,margin:'10px 0 0'}}>สแกนจ่ายผ่านแอปธนาคารของคุณค่ะ</p>
      </div>

      <div style={{background:c.card,border:`1px solid ${c.cardBorder}`,borderRadius:'12px',padding:'12px',display:'flex',flexDirection:'column',gap:'10px'}}>
        <p style={{fontSize:'11px',color:c.sub,margin:0}}>ยอดเงินที่โอน (ไม่บังคับ)</p>
        <input
          value={amount}
          onChange={e => setAmount(e.target.value)}
          type="number"
          placeholder="เช่น 200"
          style={{background:c.inp,border:`1px solid ${c.inpBorder}`,borderRadius:'8px',padding:'9px 10px',fontSize:'13px',color:c.inpText,fontFamily:'Prompt,sans-serif',width:'100%',boxSizing:'border-box'}}
        />

        <p style={{fontSize:'11px',color:c.sub,margin:0}}>แนบรูปสลิป</p>
        <label style={{
          display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:'6px',
          border:`1.5px dashed ${c.inpBorder}`,borderRadius:'10px',padding:'18px',cursor:'pointer',
          background:c.inp,
        }}>
          {preview ? (
            <img src={preview} alt="ตัวอย่างสลิป" style={{maxWidth:'160px',maxHeight:'200px',borderRadius:'8px'}} />
          ) : (
            <>
              <i className="ti ti-camera" style={{fontSize:'26px',color:'#FF4500'}} aria-hidden="true"/>
              <span style={{fontSize:'11.5px',color:c.sub}}>แตะเพื่อเลือกรูปสลิป</span>
            </>
          )}
          <input type="file" accept="image/*" onChange={handleFileChange} style={{display:'none'}} />
        </label>
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading || !file}
        style={{
          width:'100%',padding:'13px',border:'none',borderRadius:'11px',
          background:file?'#FF4500':'#555',
          color:'#fff',fontSize:'13px',fontWeight:'700',
          cursor:file?'pointer':'not-allowed',
          fontFamily:'Prompt,sans-serif'
        }}
      >
        {loading ? 'กำลังตรวจสอบสลิป...' : 'ส่งตรวจสอบสลิป'}
      </button>

    </div>
  );
}

export default TopupPage;